module.exports = __webpack_public_path__ + "static/media/download.78ef405c.txt";